module.exports = __webpack_public_path__ + "static/media/icon-skills.9a644a63.svg";